import { useEffect, useState } from "react";

import { toast } from "react-toastify";
import { ICustomerInvoicesDto } from "../dtos/ICustomerInvoicesDto";
import { ICustomerInvoiceModel } from "../models/ICustomerInvoiceModel";
import { CustomerInvoicesService } from "src/services/documents/CustomerInvoicesService";
import { AppEntities } from "src/config/entities";
import { ICustomerInvoiceProductDto } from "../dtos/ICustomerInvoiceProductDto";
import { ICustomerInvoiceServiceDto } from "../dtos/ICustomerInvoiceServiceDto";
import { ICustomerInvoicePaymentOffsetDto } from "../dtos/ICustomerInvoicePaymentOffsetDto";

interface IProps {
  documentId?: string;
}

export const useFetchCustomerInvoice = ({ documentId }: IProps) => {
  const [isDocumentLoading, setIsDocumentLoading] = useState(false);
  const [documentDto, setDocumentDto] = useState<ICustomerInvoicesDto | null>(null);
  const [documentModel, setDocumentModel] = useState<ICustomerInvoiceModel | null>(null);
  const dataService = AppEntities.CustomerInvoices.getDataService() as CustomerInvoicesService;

  const postDocument = async () => {
    if (!documentId) return;
    await dataService.PostDocument(documentId);
    toast.success("Document posted successfully");
  };

  const cancelDocument = async () => {
    if (!documentId) return;
    await dataService.CancelDocument(documentId);
    toast.success("Document canceled successfully");
  };

  const updateDocument = async (documentModel: ICustomerInvoiceModel) => {
    if (!documentId) return;
    console.log(documentModel);
    const requestDto: ICustomerInvoicesDto = { ...documentModel };
    const responseDto = await dataService.Update(requestDto);
    setDocumentDto(responseDto);
    // toast.success("Document updated successfully");
  };

  const fetchDocument = async () => {
    try {
      setIsDocumentLoading(true);


      let responseDto: ICustomerInvoicesDto | null = null;
      let responseProductsDto: ICustomerInvoiceProductDto[] = [];
      let responseServicesDto: ICustomerInvoiceServiceDto[] = [];
      let responsePaymentOffsets: ICustomerInvoicePaymentOffsetDto[] = [];
      if (!documentId) {
        responseDto = await dataService.Create({
          documentDate: new Date()
        });
        setDocumentDto(responseDto);
      } else {
        responseDto = await dataService.Get(documentId);
        setDocumentDto(responseDto);
      }

      if (!responseDto) return;

      const newModel: ICustomerInvoiceModel = {
        ...responseDto,
        products: [...responseProductsDto],
        services: [...responseServicesDto],
        paymentOffsets: [...responsePaymentOffsets]
      };
      setDocumentModel(newModel);
    } catch (e) {
      console.log(e);
    } finally {
      setIsDocumentLoading(false);
    }
  };

  useEffect(() => {
    fetchDocument();
  }, [documentId]);

  return {
    isDocumentLoading,
    documentDto,
    documentModel,
    postDocument,
    cancelDocument,
    updateDocument
  };
};
